import React, { isValidElement } from 'react';
import { Icon } from './icon.js';
import { Image } from './image.js';
import './inline-image.css';
function InlineImage(props) {
    const { src } = props;
    if (isValidElement(src)) {
        return React.createElement(Icon, { className: props.className, icon: src, onClick: props.onClick });
    }
    return React.createElement(Image, { ...props, src: src });
}
export { InlineImage, };
//# sourceMappingURL=inline-image.js.map